/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetServices200ResponseData } from './GetServices200ResponseData'
import {
  GetServices200ResponseDataFromJSON,
  GetServices200ResponseDataFromJSONTyped,
  GetServices200ResponseDataToJSON,
} from './GetServices200ResponseData'

/**
 *
 * @export
 * @interface GetServices200Response
 */
export interface GetServices200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetServices200Response
   */
  status: boolean
  /**
   *
   * @type {GetServices200ResponseData}
   * @memberof GetServices200Response
   */
  data: GetServices200ResponseData
}

/**
 * Check if a given object implements the GetServices200Response interface.
 */
export function instanceOfGetServices200Response(
  value: object
): value is GetServices200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetServices200ResponseFromJSON(
  json: any
): GetServices200Response {
  return GetServices200ResponseFromJSONTyped(json, false)
}

export function GetServices200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetServices200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetServices200ResponseDataFromJSON(json['data']),
  }
}

export function GetServices200ResponseToJSON(
  value?: GetServices200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetServices200ResponseDataToJSON(value['data']),
  }
}
